import React, { useEffect, useRef, useState } from "react";
import { useLocalStorageState, useMount, useScroll } from "ahooks";
import general, { redux } from "../../general";
import "swiper/swiper-bundle.css";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { Link, useHistory } from "react-router-dom";
import { NavLink } from "../../lib/Navigation";
import dayjs from "dayjs";
import useActiveState from "../../lib/useActiveState";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import _useLocalStorageState from "../../lib/useLocalStorageState";
import urlMatching from "../../utils/urlMatching";
import Act from "./Act";
import { sysUrl, activityUrl } from "../../config";
import HeadNew from "./HeadNew";
import { splitStr } from "../../utils/commonFunc";
import { sortEncodeAndHash } from "../../utils/signFunc";
import { getKidCallback, userClickReport } from "../../utils/kidCallback";
import { storageLocal } from "../util/storage";

// 初始化Swiper模块
SwiperCore.use([Autoplay, Pagination]);

// 首页不同区域游戏列表展示
const swipers = [];

const View = (props) => {
  let history = useHistory();
  const [app] = useActiveState("app");
  const [user] = useActiveState("user");

  const [loading, setLoading] = useState();
  const [banners, setBanners] = _useLocalStorageState("good-banner", {
    defaultValue: [],
  });
  const [popularGame, setPopularGame] = _useLocalStorageState(
    "good-popularGame",
    { defaultValue: [] }
  );

  const [gameDatas, setGameDatas] = _useLocalStorageState("good-data", {
    defaultValue: [],
  });
  const [selectiveSlassification, setSelectiveSlassification] = useState([]);

  const [advertis, setAdvertis] = useState(null);
  const [actActive, setActActive] = useState(false);
  const [bannersReady, setBannersReady] = useState(
    banners && banners.length > 0
  );

  const load = () => {
    if (loading) {
      return;
    }
    setActActive(true);
    setLoading(true);
    // Dialog.loading();
    // /base/newindex/getHomeGameList
    general.axios
      .post("/v3/base/apphome/getAppHome", {
        device: "web",
        channel: localStorage.getItem("agent") || "x7z1",
      })
      .finally(() => {
        setLoading(false);
        // Dialog.close();
      })
      .then((res) => {
        let { status, data } = res.data;
        console.log("首页整体数据----------------", data);
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }

        // 顶部搜索框-自定义标签 数据
        data.tag && props.setExtra(data.tag);

        // 顶部banner数据
        setBanners(data.banner);
        setBannersReady(true);

        // 胶囊
        setPopularGame(data.capsule);

        // 游戏及专题列表
        setGameDatas(data.list);

        // 精选分类
        setSelectiveSlassification(data.itemize);

        setActActive(false);

        // 首页广告
        if (data.ad) {
          props.setAdvertising(data.ad);
          setAdvertis(data.ad);
        }
      })
      .catch((err) => {
        console.log(err);
        Dialog.error(err.message);
      });
  };

  // 监听banners变化，如果有缓存数据立即设置ready状态
  useEffect(() => {
    if (banners && banners.length > 0) {
      setBannersReady(true);
    }
  }, [banners]);

  useEffect(() => {
    // && !init

    if (props.active) {
      load();
    }
  }, [props.active]);

  const swiperRef = useRef(null);
  const swiperPopularRef = useRef(null);

  useEffect(() => {
    if (
      popularGame.length > 0 &&
      swiperPopularRef.current &&
      swiperPopularRef.current.swiper
    ) {
      setTimeout(() => {
        swiperPopularRef.current.swiper.update();
        swiperPopularRef.current.swiper.updateSlides();
        swiperPopularRef.current.swiper.updateAutoHeight();
      }, 300);
    }
  }, [popularGame]);

  // 当bannersReady状态变化时，重新初始化Swiper
  useEffect(() => {
    if (bannersReady && swiperRef.current && swiperRef.current.swiper) {
      // 延迟300ms进行更新，确保容器已加载完毕
      setTimeout(() => {
        swiperRef.current.swiper.update();
        swiperRef.current.swiper.updateSlides();
        swiperRef.current.swiper.updateAutoHeight();
      }, 300);
    }
  }, [bannersReady]);

  // 当banners数据变化时，更新Swiper
  useEffect(() => {
    if (
      banners &&
      banners.length > 0 &&
      swiperRef.current &&
      swiperRef.current.swiper
    ) {
      setTimeout(() => {
        swiperRef.current.swiper.update();
      }, 100);
    }
  }, [banners]);

  const scroll = useScroll();
  const [searchIconShow, setSearchIconShow] = useState(false);
  useEffect(() => {
    if (scroll && scroll.top) {
      setSearchIconShow(true);
    } else {
      setSearchIconShow(false);
    }
  }, [scroll, props.active]);

  useEffect(() => {
    props.active && swipers.forEach((swiper) => swiper.update());
  }, [props.active, gameDatas]);

  const [firstActivity, setFirstActivity] = useState(false);

  const [activity, setActivity] = useLocalStorageState("activity");
  const [activityShow, setActivityShow] = useState();
  const [activityTime, setActivityTime] = useLocalStorageState(
    "activityed-" + dayjs().format("YYYY-MM-DD")
  );
  useMount(() => {
    general.axios
      .post("/v3/base/activity/getActivityNew")
      .then((res) => {
        let { status, data } = res.data;
        console.log("新人福利弹窗-------", data);
        if (status.succeed) {
          setActivity(data || null);
        }
      })
      .catch((err) => {
        Dialog.error(
          <div style={{ textAlign: "center" }}>
            <div>请求失败，请稍后重试~</div>
            <div style={{ fontSize: "0.2rem" }}>{err.message}</div>
          </div>
        );
      });
  });

  const [appUdid, setAppUdid] = useState(false);
  let [agent] = useActiveState("agent");
  let [key] = useActiveState("key");

  const [first, setFirst] = useLocalStorageState("first", {
    defaultValue: true,
  });
  const [alert, setAlert] = useState();

  const [guide] = useActiveState("guide");

  // 图片加载完成后更新 Swiper 高度
  const handleImageLoad = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.updateAutoHeight();
    }
  };

  const [entranceDataList, setEntranceDataList] = useLocalStorageState(
    "entranceDatasList",
    {
      defaultValue: [
        // {
        //   id: 1,
        //   title: "双648福利",
        //   desc: "免费领648",
        //   url: sysUrl + "/home/welfare648",
        //   icon: "648",
        // },
        {
          id: 1,
          title: "每日抽奖",
          desc: "赢取超值奖品",
          url: sysUrl + "/home/growth/draw",
          icon: "draw",
        },
        {
          id: 2,
          title: "省钱卡",
          desc: "福利币每天领",
          url: sysUrl + "/home/MonthCard",
          icon: "card",
        },
        {
          id: 3,
          title: "有奖试玩",
          desc: "边玩边赚",
          url: activityUrl + "/play-win",
          icon: "play",
        },
        {
          id: 5,
          title: "超级会员",
          desc: "专享特权",
          url: sysUrl + "/home/SuperMember",
          icon: "super",
        },
      ],
    }
  );

  // 金刚区显示签到还是超级会员
  const signShowCallback = () => {
    const time = new Date().getTime().toString();

    let objData = {
      applyType: 1,
      code: "sign",
    };

    general.axios
      .post("/v4/channel_rule", objData, {
        headers: {
          sign: sortEncodeAndHash({
            ...objData,
            timestamp: time,
          }),
          timestamp: time,
        },
      })
      .then((res) => {
        console.log("签到展示回调--------", res);

        if (res.data.code !== 200) {
          Dialog.error(res.data.msg);
          return;
        }

        let data = entranceDataList;
        if (res?.data?.data?.status == 1) {
          console.log("entranceDataList-----", data);
          data.splice(-1, 1, {
            id: 4,
            title: "签到",
            desc: "福利币每天领",
            url: activityUrl + "/sign-in",
            icon: "signin",
          });

          setEntranceDataList(data);
        } else {
          data.splice(-1, 1, {
            id: 5,
            title: "超级会员",
            desc: "专享特权",
            url: sysUrl + "/home/SuperMember",
            icon: "super",
          });

          setEntranceDataList(data);
        }
      })
      .catch((err) => {
        console.log("签到展示回调--------", err);
      });
  };
  useEffect(() => {
    signShowCallback();
  }, []);

  const searchStartClick = async () => {
    console.log("首页搜索开始点击");

    // 同步生成二级kid
    let kid = await getKidCallback();
    // 存储二级kid
    sessionStorage.setItem("boxSecondKid", kid);

    // 行为上报
    // 一级kid、二级kid都进行传递
    let reamrk = {
      search_click_time: dayjs().unix(),
      search_click_position: "首页",
    };
    userClickReport({
      target_action_type: "search",
      parent_id: "",
      kid,
      level: 2,
      action_code: "search_click",
      remark: JSON.stringify(reamrk),
    });
  };

  return (
    <>
      <Link
        to="/search"
        className={
          searchIconShow ? "show index-search-icon" : "index-search-icon"
        }
        onClick={searchStartClick}
      >
        <img src="/resources/common/search.png" alt="" />
      </Link>

      <div onClick={searchStartClick}>
        <HeadNew active={props.active} />
      </div>

      <div
        className="index-good"
        style={{
          paddingBottom: storageLocal.has("kfUrl") ? "40px" : "0",
        }}
      >
        {/* 顶部banner */}
        {banners && banners.length > 0 && bannersReady ? (
          <div className="index-banner">
            <Swiper
              ref={swiperRef}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
            >
              {banners?.map((item, index) => (
                <SwiperSlide key={index} className="index-banner-slide">
                  <NavLink
                    user={item.if_check == 1 ? true : false}
                    iframe={
                      item.type == "outer_h5" ? { title: item.text } : null
                    }
                    to={urlMatching(item)}
                    href={item.type == "outer_contact" ? item.param : ""}
                  >
                    <img
                      src={item.img}
                      className="index-banner-img"
                      alt=""
                      onLoad={handleImageLoad}
                    />
                  </NavLink>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : null}

        {/* 常用功能入口 */}
        {entranceDataList.length > 0 && (
          <div className="index-menus">
            {entranceDataList.map((menu) => (
              <NavLink
                key={menu.id}
                className="menu"
                to={menu.url}
                iframe={{
                  title: menu.title == "签到" ? "每日签到" : menu.title,
                }}
                user={false}
              >
                <div className="menu-font">
                  <div className="name">{menu.title}</div>
                  <div className="thumb">{menu.desc}</div>
                </div>

                <div className="icon">
                  <Image src={`/resources/index/${menu.icon}.png`} alt="" />
                </div>
              </NavLink>
            ))}
          </div>
        )}

        {/* 胶囊 */}
        {popularGame.length ? (
          <div className="index-activity_top">
            <Swiper
              ref={swiperPopularRef}
              loop={true}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
            >
              {popularGame.map((item) => (
                <SwiperSlide key={item.id}>
                  <NavLink
                    user={item.if_check == 1 ? true : false}
                    iframe={
                      item.type == "outer_h5" ? { title: item.title } : null
                    }
                    to={urlMatching(item)}
                    href={item.type == "outer_contact" ? item.param : ""}
                  >
                    <img src={item.img} alt="" />
                  </NavLink>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : null}

        {/* 游戏及专题展示 */}
        {gameDatas.map((item) => {
          // 1 游戏列表 2 专题
          return item.type == 1 ? (
            item.ob_type == 1 ? (
              <div
                className="index-data recommendGames"
                style={{ padding: "16px 13px 18px" }}
                key={item.id}
              >
                <div className="data-head ">
                  <div className="text">{item.title}</div>
                </div>
                <div className="data-body ">
                  <div className="items">
                    {item.details.map((game) => (
                      <Link
                        to={"/game?id=" + game.game_id}
                        key={game.game_id}
                        className="item"
                      >
                        <div className="icon" style={{ position: "relative" }}>
                          <Image src={game.icon} />
                        </div>

                        <div className="name">{game.game_name_main}</div>
                        <div className="info">{splitStr(game.version)}</div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            ) : item.ob_type == 2 ? (
              <div className="index-data columnGames" key={item.id}>
                <div className="data-head columnGames-head">
                  <span className="text">{item.title}</span>
                </div>
                <div className="data-body columnGames">
                  {item.details.map((game, index) => (
                    <Link
                      style={{
                        paddingBottom:
                          game.is_show_banner_url == 1 &&
                          index === item.details.length - 1
                            ? 0
                            : "16px",
                      }}
                      to={"/game?id=" + game.game_id}
                      key={game.game_id}
                    >
                      <div className="game-list-global-type columnGames">
                        <div className="game-list-global-type-left">
                          <div className="icon">
                            <Image src={game.icon} />
                          </div>

                          <div className="data">
                            <div className="name">
                              <div className="name-main">
                                {game.game_name_main || game.game_name}
                              </div>

                              {game?.game_tags?.is_special_server_game == 2 && (
                                <div className="dedicated-server">专服</div>
                              )}
                            </div>

                            <div className="desc">
                              {splitStr(game.version)}
                              {game.game_name_branch && (
                                <>
                                  <div className="circle"></div>
                                  {game.game_name_branch}
                                </>
                              )}
                            </div>

                            <div className="info">
                              {game.benefits && (
                                <>
                                  {game?.is_trial_game == 2 ? (
                                    <>
                                      <div className="play-tag">有奖试玩</div>
                                      {game.benefits
                                        ?.split("+")
                                        .slice(0, 1)
                                        .map((item, index) => (
                                          <div key={index} className="tag">
                                            {item}
                                          </div>
                                        ))}
                                    </>
                                  ) : (
                                    game.benefits
                                      ?.split("+")
                                      .slice(0, 2)
                                      .map((item, index) => (
                                        <div key={index} className="tag">
                                          {item}
                                        </div>
                                      ))
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>

                        {game?.game_tags?.is_premium_game == 2 ? (
                          <div
                            className="is-premium"
                            style={{
                              backgroundImage:
                                "url('/resources/common/boutique.png')",
                            }}
                          >
                            {game.discount < 1 ? (
                              <p className="is-premium-discount">
                                {parseFloat((game.discount * 10).toFixed(2))}折
                              </p>
                            ) : null}
                            <p className="boutique">精品游戏</p>
                          </div>
                        ) : game?.game_tags?.is_free_version == 2 ? (
                          <div className="is-free-version">
                            <span>免费版</span>
                          </div>
                        ) : (
                          <>
                            {game.discount < 1 ? (
                              <div className="discount">
                                {parseFloat((game.discount * 10).toFixed(2))}折
                              </div>
                            ) : null}
                          </>
                        )}
                      </div>

                      {game.is_show_banner_url == 1 ? (
                        <div className="columnGames-bigImg">
                          <Image src={game.banner_url} />
                        </div>
                      ) : null}
                    </Link>
                  ))}
                </div>
              </div>
            ) : item.ob_type == 3 ? (
              <div key={item.id}>
                {item.details.map((game) => (
                  <div key={game.game_id} className="index-new-game-promotion">
                    <NavLink
                      user={item.if_check == 1 ? true : false}
                      to={
                        item.jump_type === "game_newinfo"
                          ? `/game?id=${game.game_id}`
                          : item.param
                      }
                      iframe={
                        item.jump_type == "outer_h5"
                          ? { title: item.title }
                          : null
                      }
                    >
                      <div className="index-new-game-promotion-top">
                        <img
                          src={item.url_img}
                          alt=""
                          className="index-new-game-promotion-img"
                        />

                        <div
                          className="new-game-welfare"
                          style={{
                            backgroundImage: `linear-gradient(to top, ${item.color} 80%, transparent)`,
                          }}
                        >
                          {item.introduction}
                        </div>
                      </div>

                      <div
                        className="index-new-game-promotion-font"
                        style={{
                          backgroundColor: item.color,
                        }}
                      >
                        <img
                          className="cut-off-rule-img"
                          src="/resources/index/cut-off-rule.png"
                          alt=""
                        />
                        <div className="item">
                          <div className="icon">
                            <Image src={game.icon} />
                            {game.game_type == 2 && game.discount < 1 ? (
                              <div className="index-all-discount">
                                <span
                                  style={{
                                    fontSize: "0.24rem",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {parseFloat((game.discount * 10).toFixed(2))}
                                </span>
                                <span style={{ fontSize: "0.2rem" }}>折</span>
                              </div>
                            ) : null}
                          </div>
                          <div style={{ overflow: "hidden" }}>
                            <div className="name">
                              <div className="game-name">
                                {game.game_name_main}
                              </div>
                              {game.game_name_branch ? (
                                <div className="versions">
                                  {game.game_name_branch}
                                </div>
                              ) : null}
                            </div>
                            <div className="info">
                              {game.version}
                              {game.played_count && game.played_count > 0 ? (
                                <div className="info" style={{ marginTop: 0 }}>
                                  <div className="circle"></div>
                                  {game.played_count}w人在玩
                                </div>
                              ) : null}
                            </div>
                            <div className="info">
                              {game.benefits
                                ? game.benefits
                                    .split("+")
                                    .map((item, index) => (
                                      <div className="desc" key={index}>
                                        {item}
                                      </div>
                                    ))
                                : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                ))}
              </div>
            ) : null
          ) : null;
        })}

        {/* 精选分类 */}
        {selectiveSlassification.length > 0 ? (
          <div
            className="index-data recommendGames"
            style={{ padding: "16px 13px" }}
          >
            <div className="data-head ">
              <div className="text">更多游戏</div>

              <div
                className="more"
                onClick={() => {
                  general.tag = 0;
                  redux.dispatch({
                    type: "type",
                    data: {
                      screenRouter: {
                        screen: "/game",
                        type: 0,
                        tag: 0,
                      },
                    },
                  });
                }}
              >
                <span>更多</span>
                <img src="/resources/index/more.png" alt="" />
              </div>
            </div>
            <div className="selective-classification">
              {selectiveSlassification.map((classify) => (
                <div
                  className="item"
                  key={classify.id}
                  style={{
                    backgroundImage: `url(${classify?.image})`,
                  }}
                  onClick={() => {
                    general.tag = classify.id;
                    redux.dispatch({
                      type: "type",
                      data: {
                        screenRouter: {
                          screen: "/game",
                          type: 0,
                          tag: classify.id,
                        },
                      },
                    });
                  }}
                >
                  {classify.tagname}
                </div>
              ))}
            </div>
          </div>
        ) : null}

        <div className="index-tips">
          <div className="text">没有更多了~</div>
        </div>

        {/* 这个样式目前直接设置的  display: none  */}
        <div className="index-float">
          <div className="item 648" onClick={() => setAlert(true)}>
            <Image
              className={app.brand == "btwan" ? "btwan" : ""}
              src={`/resources/index/${
                app.brand == "btwan"
                  ? "alert-btwan"
                  : user.back2203
                  ? "back2203"
                  : "float-648"
              }.png`}
              alt=""
            />
          </div>
          {activity ? (
            <div className="item first" onClick={() => setActivityShow(true)}>
              <Image src={activity.thumb} alt="" />
            </div>
          ) : !user.isLogin || !user.is_finish_newtask ? (
            <div className="item first" onClick={() => setFirstActivity(true)}>
              <Image src="/resources/index/float-first.png" alt="" />
            </div>
          ) : null}
        </div>

        {/* data目前返回都为null  此模块也都一直不显示 */}
        {activity ? (
          <>
            {!activityTime || activityShow ? (
              <div className="activity-first">
                <div className="container">
                  <NavLink
                    to={
                      activity.type == "outer_h5"
                        ? activity.url
                        : `/game?id=${activity.url}`
                    }
                    iframe={{ title: activity.name }}
                    onClick={() => {
                      setActivityShow(false);
                      setActivityTime(true);
                    }}
                  >
                    <div className="img">
                      <Image src={activity.img} alt="" />
                    </div>
                  </NavLink>
                  <div
                    className="close"
                    onClick={() => {
                      setActivityShow(false);
                      setActivityTime(true);
                    }}
                  >
                    X
                  </div>
                </div>
              </div>
            ) : null}
          </>
        ) : firstActivity ? (
          <div className="activity-first">
            <div className="container">
              <NavLink
                to="/screen-welfare"
                onClick={() => setFirstActivity(false)}
              >
                <div className="img">
                  <Image src="/resources/index/activity-first.png" alt="" />
                </div>
                <div className="btn">立即领取</div>
              </NavLink>
              <div className="close" onClick={() => setFirstActivity(false)}>
                X
              </div>
            </div>
          </div>
        ) : null}

        {navigator.userAgent == "app" &&
        !appUdid &&
        !general.isLogin() &&
        key &&
        false ? (
          <div className="app-udid">
            <div className="container">
              <div
                className="img"
                onClick={() => {
                  history.push("login");
                  /*window.location.href = URI('app://browser')
            .addQuery('url', URI('https://app.9917.cn/udid/').addQuery('url', URI(window.location.href)
                .hash(
                  URI(location.pathname + location.search + location.hash)
                    .addQuery('agent', agent)
                    .addQuery('key', key)
                    .addQuery('auto', 1)
                    .toString())
                .toString()
              )
                .toString()
            ).toString();*/
                  /*window.location.href = URI('app://browser')
            .addQuery('url', `itms-services://?action=download-manifest&url=${encodeURIComponent(`https://iosd.9917.cn/152/${agent}/manifest`)}`)
            .toString();*/
                  setAppUdid(true);
                }}
              >
                <Image src="/resources/index/app.png" alt="" />
              </div>
              <div
                className="btn"
                onClick={() => {
                  history.push("login");
                  /*window.location.href = URI('app://browser')
            .addQuery('url', `itms-services://?action=download-manifest&url=${encodeURIComponent(`https://iosd.9917.cn/152/${agent}/manifest`)}`)
            .toString();*/
                  setAppUdid(true);
                }}
              >
                立即领取
              </div>
              <div className="close" onClick={() => setAppUdid(true)}>
                X
              </div>
            </div>
          </div>
        ) : null}

        {(first &&
          window.navigator.standalone &&
          navigator.userAgent != "app" &&
          !user.isLogin &&
          app.brand !== undefined) ||
        alert ||
        (user?.back2203 && user.back2203.receive != 1) ? (
          <div className="app-alert">
            <div className="container">
              <NavLink
                className="img"
                to={`${sysUrl}/home/NewPerson2`}
                iframe={{ title: "新人见面礼" }}
              >
                <Image
                  src={`/resources/index/${
                    user.back2203
                      ? "back2203"
                      : `alert${app.brand ? `-${app.brand}` : ""}`
                  }.png`}
                  alt=""
                  onClick={() => {
                    setFirst(false);
                    setAlert(false);
                  }}
                />
              </NavLink>
              <div
                className="close"
                onClick={() => {
                  setFirst(false);
                  setAlert(false);
                }}
              >
                X
              </div>
            </div>
          </div>
        ) : null}

        {/*{!guide ? <Act/> : null}*/}
        <Act advertis={advertis} isShow={props.isShow} active={actActive} />
      </div>
    </>
  );
};

export default (props) => {
  const [state, setState] = useState(123);
  const scroll = useScroll();
  useEffect(() => {
    if (props.active && scroll && scroll?.top < -80) {
      setState(dayjs().unix());
    }
  }, [scroll, props.active]);

  return <View {...props} key={state} />;
};
